<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HH6Zup/tc-custom/9780814341056.jpg?1724210075558" alt="This image is the cover for the book Garden for the Blind, Made in Michigan Writers Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Garden for the Blind, Made in Michigan Writers Series
      </h1>
      <p class="bookDescription body article font2">
        
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelly Fordon
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19eaf670